import {
  browserSupportsWebAuthn,
  browserSupportsWebAuthnAutofill,
  platformAuthenticatorIsAvailable,
} from '@simplewebauthn/browser';

export const PasskeySupportLevels = {
  UNSUPPORTED: 'UNSUPPORTED',
  PARTIAL: 'PARTIAL',
  FULL: 'FULL',
};

// Same idea as GitHub: a browser can expose WebAuthn but still be unable to use
// passkeys, e.g. in-app browsers like the Google app on iOS. Those report no
// platform authenticator or no passkey autofill.
export const getPasskeySupportLevel = async () => {
  if (!browserSupportsWebAuthn()) {
    return PasskeySupportLevels.UNSUPPORTED;
  }

  try {
    const [hasPlatformAuthenticator, hasPasskeyAutofill] = await Promise.all([
      platformAuthenticatorIsAvailable(),
      browserSupportsWebAuthnAutofill(),
    ]);
    return hasPlatformAuthenticator && hasPasskeyAutofill
      ? PasskeySupportLevels.FULL
      : PasskeySupportLevels.PARTIAL;
  } catch {
    return PasskeySupportLevels.PARTIAL;
  }
};

// A browser with partial support refuses with the same NotAllowedError as a
// user cancellation, so it can only be told apart by the support level
export const isRefusedByPartialPasskeySupport = async (error) => {
  if (error?.name !== 'NotAllowedError') {
    return false;
  }
  const supportLevel = await getPasskeySupportLevel();
  return supportLevel === PasskeySupportLevels.PARTIAL;
};
